// TOGGLE MOBILE NAV
const open = document.querySelector(".main-header")
const mobileMenu = document.querySelector(".main-header__nav")
const hamburger = document.querySelector(".main-header__hamburger-btn")


hamburger.addEventListener("click", function () {
  if (open.classList.contains("open")) {
    open.classList.remove("open")
  } else {
    open.classList.add("open")
  }
})

document.addEventListener("click", function (event) {
  const isClickInside = hamburger.contains(event.target);
  const isClickInside2 = mobileMenu.contains(event.target);

  if (!isClickInside && !isClickInside2) {
    open.classList.remove("open")
  }

});

//Mobile submenu init
function mobileSubmenuInit() {
  const menuItemHasChildren = document.querySelectorAll(".menu-item-has-children")
  menuItemHasChildren.forEach(item => {
    item.children[0].insertAdjacentHTML('afterend', '<span class="sub-menu-button"></span>');
  });
}
mobileSubmenuInit();

//Mobile submenu
function mobileSubmenu() {
  const subMenuButtons = document.querySelectorAll(".sub-menu-button");
  subMenuButtons.forEach(button => {
    button.addEventListener("click", function () {
      let item = button
      if (!item.classList.contains("js-open")) {
        item.classList.add("js-open");
        item.parentNode.classList.add("js-open");
        item.parentNode.querySelector(".sub-menu").classList.add("js-open");

      } else {
        item.classList.remove("js-open");
        item.parentNode.classList.remove("js-open");
        item.parentNode.querySelector(".sub-menu").classList.remove("js-open");


        if (item.parentNode.querySelector(".sub-menu .sub-menu")) {
          item.parentNode.querySelector(".sub-menu .sub-menu").classList.remove("js-open");
        }
      }
    });
  });
}

mobileSubmenu();


// HEADROOM.JS

import Headroom from "headroom.js";

const mainHeader = document.querySelector(".main-header");

const mainHeaderHeight = mainHeader.clientHeight;

const headRoomHeaderOptions = {
  offset: mainHeader?.clientHeight ?? 0,
};

export const headRoomHeader = new Headroom(mainHeader, headRoomHeaderOptions);

if (mainHeader !== null) {
  const topOffset =  mainHeaderHeight > mainHeader.clientHeight ? mainHeaderHeight : mainHeader.clientHeight;

  headRoomHeader.init();

  const mainContent = document.querySelector('main');

  const resizeObserver = new ResizeObserver(() => {
    mainContent.style.paddingTop = `${topOffset}px`
    document.querySelector("body, html").style.scrollPaddingTop = `${topOffset}px`
  });

  resizeObserver.observe(mainHeader);
}

// buttons move
const mainNav = document.querySelector(".main-nav__list"); //navigace
const mainTop = document.querySelector(".main-header__buttons"); //to co chci přesunout
const mainHeaderGrid = document.querySelector(".main-header__cta");

const mobileQuery = window.matchMedia("(max-width: 1200px)");

const handleMobileChange = (mediaQueryList) => {
  if (!mainTop) return;

  if (mediaQueryList.matches) {
    mainNav.prepend(mainTop)
  } else {
    mainHeaderGrid.append(mainTop)
  }
};

mobileQuery.addEventListener("change", handleMobileChange);
handleMobileChange(mobileQuery);

//Header lang
function headerLang() {

  const langCurrent = document.querySelector(".language-switcher__current");
  if (!langCurrent) {
    return
  }
  const langList = document.querySelector(".language-switcher__list");
  const otherElements = document.querySelector(".language-switcher *");

  langCurrent.addEventListener("click", function () {
    langList.classList.toggle("js-open");
  });

  //Close
  document.addEventListener("click", function (e) {
    if (otherElements !== e.target && langList !== e.target && langList.classList.contains("js-open")) {
      langList.classList.remove("js-open");
    }
  });

}

headerLang();
